import React from 'react';
import {View, ViewStyle, Image} from 'react-native';
import {Images} from '../../../assets';
import {Components, Theme} from '@oneamerica/dxp-ui-components';
import responsiveStyles from './styles';

const Header = () => {
  const styles = responsiveStyles();
  const renderOALogo = () => {
    return (
      <Components.Link
        accessibilityLabel="One America logo Image"
        accessibilityRole="button"
        testID="header:logo"
        focusStyle={
          {
            outlineWidth: 1,
            outlineColor: Theme.Color.ice4,
            outlineStyle: 'solid',
            outlineOffset: 1,
            padding: 0,
          } as ViewStyle
        }>
        <Image
          source={Images.oa_logo_color}
          alt="OneAmerica logo"
          style={{
            width: 159,
            height: 40,
          }}
          resizeMode="contain"
        />
      </Components.Link>
    );
  };

  return (
    <View testID="header" className="fixed w-full z-50">
      <View style={{backgroundColor: Theme.Color.oaBlue}} className="hidden md:items-center md:flex">
        <View
          style={styles.headerContainer}
          className="md:py-2 md:w-full md:flex md:flex-row md:items-center md:justify-between md:h-[30px]"
        />
      </View>
      <View
        className="w-full h-[10px] md:border-t-0 md:h-[92px] py-8 md:py-0 items-center"
        pointerEvents="box-none"
        style={{backgroundColor: Theme.Color.white}}>
        <View
          style={styles.headerContainer}
          className="w-full flex-row justify-around items-start mx-auto h-full items-center"
          pointerEvents="box-none">
          <View className="flex-row flex-1 items-center">{renderOALogo()}</View>
          <View className="flex-row h-full" />
        </View>
      </View>
    </View>
  );
};

export default Header;
